import { Box, Divider, Stack } from '@mui/material';
import React from 'react';

import { MobileCaption, MobileSubtitle } from '../Typography';

export interface StatNumberProps {
  label: string;
  amount: string | number;
  tag?: string;
  sx?: object;
}

const StatNumber: React.FC<StatNumberProps> = ({ label, amount, tag, sx }) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={0}
      sx={{ width: '100%', ...sx }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
          pb: 0.5,
        }}
      >
        <MobileSubtitle
          component="span"
          sx={{
            color: 'text.primary',
            fontSize: '0.8125rem',
            fontWeight: 700,
          }}
        >
          {label}
        </MobileSubtitle>
      </Box>
      <Divider flexItem sx={{ width: '100%', borderColor: 'divider' }} />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'baseline',
          gap: 0.375,
          pt: 0.5,
        }}
      >
        <MobileSubtitle
          component="span"
          sx={{
            color: 'text.primary',
            fontSize: '1.25rem',
            fontWeight: 500,
            lineHeight: 1.2,
          }}
        >
          {amount}
        </MobileSubtitle>
        {tag != null && tag !== '' && (
          <MobileCaption
            component="span"
            sx={{
              color: 'text.secondary',
              fontSize: '0.75rem',
              fontWeight: 500,
            }}
          >
            {tag}
          </MobileCaption>
        )}
      </Box>
    </Stack>
  );
};

export default StatNumber;
